import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import * as fromRootStore from "../../../../reducers";
import {
  Combo2Service,
  ExcelService,
  PurchaseReportService,
} from "../../../../services/index";
declare var google;

@Component({
  selector: "factory-report",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./factoryReport.html",
})
export class factoryReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();
  backbutExists: boolean = false;
  seasonList = [];
  gridOptions: any;
  dataList = [];
  qualityList: any;
  typeList: any;
  colorList: any;
  codeList: any;
  widthList: any[];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  finyearList = [];
  tally_qty: number = 0;
  filter = {
    groupby: "factory",
    department: "",
    fab_type: "",
    brand: "",
    width: "",
    style: "",
    fab_style: "",
    cutting_ratio: "",
    groupby1: "",
    ps_department: "",
    cu_no: "",
    cp_date: "",
    unit_name: "",
    menu_param: ""
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "po_no",
    orderDir: "asc",
  };
  printConfig: any = {
    title: "Cutting Report",
    columns: [],
    rows: [],
  };

  partyList = [];
  exceldata: any;

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  columns = [];
  partycodeList = [];
  toggleCol = [];
  menu: any;
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private excelService: ExcelService,
    private purReport: PurchaseReportService,
    public datePipe: DatePipe,
    private combo2Service: Combo2Service,
    public toasterService: ToasterService
  ) {
    this.colorList = [
      "lightcyan",
      "bisque",
      "lightblue",
      "lightgoldenrodyellow",
      "thistle",
      "floralwhite",
      "rgba(200, 247, 197, 1)",
      "rgb(246 222 167)",
      "#cec4aa",
      "lightblue",
    ];
  }

  ngOnInit(): void {
    this.getColumns();
    // this.finyearCombo();
    this.toggleCol = Object.assign({}, this.columns);
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    this.columns = [];

    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };
    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }
  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }

  onCellClick(event) {
    let row = event.row;

    if (this.filter.groupby == "department") {
      if (
        this.filter.department == "F.F STORE" ||
        this.filter.department == "UNAPPROVED DC (WO)"
      ) {
        this.filter.fab_type = row.fab_type;
        this.filter.brand = row.brand;
        this.filter.width = row.width;
        this.filter.fab_style = row.fab_style;
        this.filter.cutting_ratio = row.cutting_ratio;
        this.filter.style = row.style;
        this.filter.groupby1 = "wo_no";
      }
      if (this.filter.department == "CUTTING PLAN") {
        this.filter.fab_type = row.fab_type;
        this.filter.brand = row.brand;
        this.filter.width = row.width;
        this.filter.style = row.style;
        this.filter.fab_style = row.fab_style;
        this.filter.groupby1 = "cu_wo_no";
      }
      if (this.filter.department == "CUTTING PENDING") {
        this.filter.fab_type = row.fab_type;
        this.filter.brand = row.brand;
        this.filter.width = row.width;
        this.filter.style = row.style;
        this.filter.fab_style = row.fab_style;
        this.filter.groupby1 = "cu_pe_wo_no";
      }
      if (this.filter.department == "REMAINING SECTIONS") {
        this.filter.fab_type = row.fab_type;
        this.filter.brand = row.brand;
        this.filter.width = row.width;
        this.filter.style = row.style;
        this.filter.fab_style = row.fab_style;
        this.filter.groupby1 = "pro_wo_no";
      }
      if (this.filter.department == "PRODUCTION STORE") {
        if (this.filter.groupby1 == "pro_store") {
          this.filter.groupby1 = "pro_store_cu_no";
          this.filter.ps_department = row.department;
        } else if (this.filter.groupby1 == "pro_store_cu_no") {
          this.filter.cu_no = row.cu_no;
          this.filter.cp_date = row.cp_date;
          this.filter.groupby1 = "pro_store_wo_no";
        }
      }
      if (this.filter.department == "FUSING") {
        this.filter.groupby1 = "fusing";
        this.filter.cu_no = row.cu_no;
        this.filter.cp_date = row.cp_date;
      }
      if (this.filter.department == "FRONT & RECUTTING") {
        this.filter.groupby1 = "fr";
        this.filter.cu_no = row.cu_no;
        this.filter.cp_date = row.cp_date;
      }
      if (this.filter.department == "STITCHING") {
        if (this.filter.groupby1 == "unit") {
          this.filter.groupby1 = "stitching_cu_no";
          this.filter.unit_name = row.unit_name;
        } else if (this.filter.groupby1 == "stitching_cu_no") {
          this.filter.groupby1 = "stitching";
          this.filter.cu_no = row.cu_no;
          this.filter.cp_date = row.cp_date;
        }
      }
      if (this.filter.department == "KAJA & BUTTON") {
        this.filter.groupby1 = "kb";
        this.filter.cu_no = row.cu_no;
        this.filter.cp_date = row.cp_date;
      }

      if (this.filter.department == "PRODUCTION") {
        this.filter.department = row.department;

        if (this.filter.department == "PRODUCTION STORE") {
          this.filter.groupby1 = "pro_store";
        }

        if (this.filter.department == "FUSING") {
          this.filter.groupby1 = "fusing_cu_no";
        }

        if (this.filter.department == "FRONT & RECUTTING") {
          this.filter.groupby1 = "fr_cu_no";
        }
        if (this.filter.department == "STITCHING") {
          this.filter.groupby1 = "unit";
        }
        if (this.filter.department == "KAJA & BUTTON") {
          this.filter.groupby1 = "kb_cu_no";
        }
        if (this.filter.department == "REMAINING SECTIONS") {
          this.filter.groupby1 = "rem_pro";
        }
      }
    }

    if (this.filter.groupby == "factory") {
      this.filter.department = row.department;
      this.filter.groupby = "department";

      if (this.filter.department == "PRODUCTION STORE") {
        this.filter.groupby1 = "pro_store";
      }

      if (this.filter.department == "FUSING") {
        this.filter.groupby1 = "fusing_cu_no";
      }

      if (this.filter.department == "FRONT & RECUTTING") {
        this.filter.groupby1 = "fr_cu_no";
      }
      if (this.filter.department == "STITCHING") {
        this.filter.groupby1 = "unit";
      }
      if (this.filter.department == "KAJA & BUTTON") {
        this.filter.groupby1 = "kb_cu_no";
      }

      if (
        this.filter.department == "WO DEL FM UNAPPROVED" ||
        this.filter.department == "WO DEL OM UNAPPROVED" ||
        this.filter.department == "RGRN PENDING"
      ) {
        this.filter.groupby1 = "wo_del";
      }
      if (this.filter.department == "PRODUCTION") {
        // this.filter.department = "WHOLE PROD";
        this.filter.groupby1 = "WHOLE PROD";
      }
    }

    this.getOrderList();
  }

  onbackbutton() {
    if (this.filter.groupby == "department") {
      if (
        this.filter.department == "F.F STORE" ||
        this.filter.department == "UNAPPROVED DC (WO)" ||
        this.filter.department == "CUTTING PLAN" ||
        this.filter.department == "CUTTING PENDING" ||
        this.filter.department == "WO DEL OM UNAPPROVED" ||
        this.filter.department == "WO DEL FM UNAPPROVED" ||
        this.filter.department == "PRODUCTION" ||
        this.filter.department == "RGRN PENDING" ||
        this.filter.department == "REMAINING SECTIONS" ||
        this.filter.department == "PRODUCTION STORE" ||
        this.filter.department == "FUSING" ||
        this.filter.department == "FRONT & RECUTTING" ||
        this.filter.department == "STITCHING" ||
        this.filter.department == "KAJA & BUTTON"
      ) {
        if (this.filter.groupby1 == "wo_no") {
          this.filter.fab_type = "";
          this.filter.brand = "";
          this.filter.width = "";
          this.filter.cutting_ratio = "";
          this.filter.fab_style = "";
          this.filter.style = "";
          this.filter.groupby1 = "";
        } else if (
          this.filter.groupby1 == "cu_wo_no" ||
          this.filter.groupby1 == "cu_pe_wo_no" ||
          this.filter.groupby1 == "pro_wo_no"
        ) {
          this.filter.fab_type = "";
          this.filter.brand = "";
          this.filter.width = "";
          this.filter.style = "";
          this.filter.fab_style = "";
          this.filter.groupby1 = "";
        } else if (this.filter.groupby1 == "pro_store") {
          this.filter.groupby = "department";
          this.filter.groupby1 = "WHOLE PROD";
          this.filter.department = "PRODUCTION";
        } else if (this.filter.groupby1 == "pro_store_cu_no") {
          this.filter.ps_department = "";
          this.filter.groupby1 = "pro_store";
        } else if (this.filter.groupby1 == "pro_store_wo_no") {
          this.filter.groupby1 = "pro_store_cu_no";
          this.filter.cp_date = "";
          this.filter.cu_no = "";
        } else if (this.filter.groupby1 == "fusing") {
          this.filter.groupby1 = "fusing_cu_no";
          this.filter.cp_date = "";
          this.filter.cu_no = "";
        } else if (this.filter.groupby1 == "fr") {
          this.filter.groupby1 = "fr_cu_no";
          this.filter.cp_date = "";
          this.filter.cu_no = "";
        } else if (this.filter.groupby1 == "stitching") {
          this.filter.groupby1 = "stitching_cu_no";
          this.filter.cp_date = "";
          this.filter.cu_no = "";
        } else if (this.filter.groupby1 == "kb") {
          this.filter.groupby1 = "kb_cu_no";
          this.filter.cp_date = "";
          this.filter.cu_no = "";
        } else if (this.filter.groupby1 == "stitching_cu_no") {
          this.filter.groupby1 = "unit";
          this.filter.cp_date = "";
          this.filter.cu_no = "";
        } else if (
          this.filter.department == "REMAINING SECTIONS" ||
          this.filter.department == "PRODUCTION STORE" ||
          this.filter.department == "FUSING" ||
          this.filter.department == "FRONT & RECUTTING" ||
          this.filter.department == "STITCHING" ||
          this.filter.department == "KAJA & BUTTON"
        ) {
          this.filter.groupby1 = "WHOLE PROD";
          this.filter.department = "PRODUCTION";
        } else {
          this.filter.groupby1 = "";
          this.filter.groupby = "factory";
          this.filter.department = "";
          this.filter.unit_name = "";
        }
      }
    }

    this.getOrderList();
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#party_code").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getOrderList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.getOrderList();
  }

  displayFinyear(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Finyear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });
      return fitem["finyear"];
    }
    return "";
  }

  getOrderList(): void {
    this.filter.menu_param = this.menu.param
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      filter: JSON.stringify(this.filter),
    };
    let that = this;
    that.gridOptions = {
      loading: true,
      columns: [],
    };
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.purReport
      .getFactoryStockReport(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.orderList = res.data;

        if (that.filter.groupby == "factory") {
          let departments = [
            "UNAPPROVED DC (WO)",
            "F.F STORE",
            "CUTTING PLAN",
            "CUTTING PENDING",
            // "PRODUCTION STORE",
            // "FUSING",
            // "FRONT & RECUTTING",
            // "STITCHING",
            // "KAJA & BUTTON",
            "PRODUCTION",
            "WO DEL OM UNAPPROVED",
            "WO DEL FM UNAPPROVED",
            "RGRN PENDING",
          ];
          let tot_ac_qty = 0;
          let tot_ac_pending = 0;
          let tot_diff = 0;
          departments.forEach((el1, index) => {
            let exist = that.orderList.findIndex((el) => el.department == el1);
            if (exist == -1) {
              that.addDept(el1, index);
            }
          });

          that.orderList.forEach((el) => {
            tot_ac_qty += Number(el.ac_qty);
            tot_ac_pending += Number(el.ac_pending);
            tot_diff += Number(el.diff);
          });

          that.tally_qty = tot_ac_qty + tot_ac_pending - tot_diff;

          //  that.orderList.sort(function(a, b){
          //   return departments.indexOf(a.department) - departments.indexOf(b.department);
          // });
          that.orderList = that.orderList.sort(function (a, b) {
            return (
              departments.indexOf(a.department) -
              departments.indexOf(b.department)
            );
          });
        }

        if (
          that.filter.department == "PRODUCTION STORE" &&
          that.filter.groupby1 == "pro_store"
        ) {
          let departments = [
            "UNAPPROVED AC",
            "UNAPPROVED FUSING",
            "UNAPPROVED F & R",
            "UNAPPROVED STITCHING",
            "UNAPPROVED K & B",
          ];

          departments.forEach((el1, index) => {
            let exist = that.orderList.findIndex((el) => el.department == el1);
            if (exist == -1) {
              that.addDeptStore(el1, index);
            }
          });
          that.orderList = that.orderList.sort(function (a, b) {
            return (
              departments.indexOf(a.department) -
              departments.indexOf(b.department)
            );
          });
        }

        if (
          that.filter.department == "PRODUCTION" &&
          that.filter.groupby1 == "WHOLE PROD"
        ) {
          let departments = [
            "PRODUCTION STORE",
            "FUSING",
            "FRONT & RECUTTING",
            "STITCHING",
            "KAJA & BUTTON",
            "REMAINING SECTIONS",
          ];

          departments.forEach((el1, index) => {
            let exist = that.orderList.findIndex((el) => el.department == el1);
            if (exist == -1) {
              that.addDeptStore(el1, index);
            }
          });
          that.orderList = that.orderList.sort(function (a, b) {
            return (
              departments.indexOf(a.department) -
              departments.indexOf(b.department)
            );
          });
        }
        if (
          that.filter.groupby == "factory" ||
          that.filter.department == "PRODUCTION" ||
          (that.filter.department == "PRODUCTION STORE" &&
            that.filter.groupby1 == "pro_store")
        ) {
          let colorlength = that.colorList.length;
          for (let i = 0; i < that.orderList.length; i++) {
            let temp = i % colorlength;
            that.orderList[i].background = that.colorList[temp];
          }
        }

        that.gridOptions = {
          cols: res.cols,
          columns: res.columns,
          data: that.orderList,
          loading: false,
        };
        that.printConfig = {
          title: "Cutting Report",
          columns: res.columns,
          rows: that.orderList,
        };
        that.exceldata = that.getData(res.columns, res.data);
        that.backbutton();
      });
  }
  addDept(dept, index) {
    let cutPlan = {
      department: dept,
      no_of_wo: "-",
      no_of_colors: "-",
      brand: "-",
      wo_qty: "-",
      ac_qty: 0,
      ac_pending: 0,
      total_ac_qty: 0,
      diff: 0,
    };
    this.orderList.splice(index, 0, cutPlan);
  }
  addDeptStore(dept, index) {
    let deptmnt = {
      department: dept,
      no_of_wo: 0,
      tot_lumps: 0,
      wo_qty: 0,
      ac_qty: 0,
    };
    this.orderList.splice(index, 0, deptmnt);
  }
  backbutton() {
    if ($(".data-history-btn").length) {
      this.backbutExists = false;
    } else {
      this.backbutExists = true;
    }
  }
  getData(columns, data) {
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  refreshData() {
    let columns = this.columns,
      data = this.dataList,
      row = this.getSummaryRow(data, columns);
    data.push(row);
    this.page.count = data.length;
    // this.dataList = data;
  }

  getSummaryRow(data, columns) {
    let row = {
      type: "summary",
    };
    for (let i = 0; i < columns.length; i++) {
      let col = columns[i];
      switch (col.summary) {
        case "sum":
          let total = 0;
          for (let j = 0; j < data.length; j++) {
            let dat = data[j];
            total += dat[col.prop];
          }
          row[col.prop] = Math.round(total * 100) / 100;
          break;
        default:
          row[col.prop] = "";
          break;
      }
    }
    return row;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/woreports/factoryReport/factoryReport.ts